import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Aesthetic%20abstract%20Chinese%20ink%20painting%20with%20flowing%20gradients%20of%20warm%20crimson%20and%20amber%20tones%2C%20traditional%20scholar%20aesthetic%20with%20soft%20textures%2C%20ancient%20book%20pages%20scattered%2C%20elegant%20artistic%20composition%2C%20no%20text%2C%20warm%20atmospheric%20lighting&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="新金瓶梅 - 经典名著全新解读"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
            新金瓶梅
          </h1>
          <p className="text-lg md:text-2xl text-background-50/90 mb-4 font-heading">
            经典名著全新解读与深度赏析
          </p>
          <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto mb-10 leading-relaxed">
            汇聚学术赏析、文化背景、人物解析与版本考证，带您重新认识这部跨越时代的文学经典，探索其蕴含的社会镜像与人性哲思。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/shendu-jiedu"
              className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              开始探索
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 border border-background-50/40 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center text-background-50/60">
          <i className="ri-arrow-down-line text-xl"></i>
        </span>
      </div>
    </section>
  );
}